(function () {
	let _lastTarget = false;
	let _target = false;
	
	function init() {
		document.addEventListener('click', dropdown);
		document.addEventListener('click', toggle);
	}
	
	function dropdown(event) {
		const _element = event.target;
		
		if (_element.hasAttribute('data-dropdown') && _element.getAttribute('data-dropdown') !== '') {
			_target = document.getElementById(_element.getAttribute('data-dropdown'));
			
			if (_element.hasAttribute('href')) {
				event.preventDefault();
			}
		} else {
			_target = false;
		}
		
		if (_lastTarget && _lastTarget !== _target && _element !== _lastTarget && !util.hasParent(_element, _lastTarget)) {
			util.removeClass(_lastTarget, 'is-visible');
			_lastTarget = false;
		}
		
		if (!_target) {
			return;
		}
		
		if (util.hasClass(_target, 'is-visible')) {
			util.removeClass(_target, 'is-visible');
			_lastTarget = false;
		} else {
			util.addClass(_target, 'is-visible');
			_lastTarget = _target;
		}
	}
	
	function toggle(event) {
		const _element = event.target;
		
		if (_element.hasAttribute('data-toggle') && _element.getAttribute('data-toggle') !== '') {
			_target = document.getElementById(_element.getAttribute('data-toggle'));
			
			if (!_target) {
				return;
			}
			
			if (_element.hasAttribute('href')) {
				event.preventDefault();
			}
			
			if (!util.hasClass(_target, 'is-visible')) {
				util.addClass(_target, 'is-visible');
				util.addClass(_element, 'is-active');
			} else {
				util.removeClass(_target, 'is-visible');
				util.removeClass(_element, 'is-active');
			}
		}
	}
	
	init();
}());